import { render, staticRenderFns } from "./Telefonos.vue?vue&type=template&id=cf3aaf62&scoped=true"
import script from "./Telefonos.vue?vue&type=script&lang=ts"
export * from "./Telefonos.vue?vue&type=script&lang=ts"
import style0 from "./Telefonos.vue?vue&type=style&index=0&id=cf3aaf62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3aaf62",
  null
  
)

export default component.exports